module.exports = __webpack_public_path__ + "img/memo_1793361691617_9500.0b3cc815.jpg";